import { Box, HStack, Shimmer, ShimmerText, VStack } from '@betterment/samba-react';

const ContributionRateEditorShimmer = () => (
  <HStack css={{ justifyContent: 'space-between', alignItems: 'center' }}>
    <ShimmerText textStyle="text25" css={{ width: '200px' }} />
    <HStack css={{ gap: 'space.150' }}>
      <Shimmer css={{ width: '120px', height: '46px' }} />
      <Shimmer css={{ width: '96px', height: '46px' }} />
    </HStack>
  </HStack>
);

export const LoadingViewContent = () => {
  return (
    <>
      <ShimmerText textStyle="title200" css={{ width: '150px' }} />
      <Box css={{ width: 'size.full' }}>
        <VStack css={{ width: 'size.full', gap: 'space.300' }}>
          <Box css={{ marginTop: 'space.100', marginBottom: 'space.200' }}>
            <ShimmerText textStyle="text25" css={{ width: '80%' }} />
          </Box>
          <VStack css={{ gap: 'space.300' }}>
            <ShimmerText textStyle="title200" css={{ width: '100px' }} />
            <ContributionRateEditorShimmer />
            <ContributionRateEditorShimmer />
          </VStack>
          <Shimmer css={{ width: '200px', height: '48px', marginTop: 'space.200' }} />
        </VStack>
      </Box>
    </>
  );
};
